import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import React from "react"
import LeaderBoards from "./LeaderBoards"
import Ratios from "./Ratios"
import BookingsInProgress from "./BookingsInProgress"
import News from "./News"

const name = "Content"

const Content: React.FC = () => {

    return (<Box id="content">
        <News />
        <Grid
            wrap="nowrap"
            container
            justifyContent="space-between"
            alignItems="flex-start"
            gap={1}
            spacing={1}
        >
            <BookingsInProgress />
            <Ratios />
            <LeaderBoards />
        </Grid >
    </Box >)
}

Content.displayName = name

export default React.memo(Content)

